export default __webpack_public_path__ + "static/Крысиные бега_14-9f6241ca1fc94208150dcdaea571e582.jpg";